import styled from 'styled-components/macro'
import { ifProp } from 'styled-tools'
import { em, calcEm } from '../../../utils/styles'

import Label from '../Label'
import SelectWrapper from '../Select/SelectWrapper';

const SelectLabel = styled(Label)`
  position: absolute;
  top: ${em(10)};
  left: ${em(15)};
  padding: 0 ${em(3)};
  background-color: #fff;
  transform-origin: 0 0;
  transform: ${ifProp('shrink',
    'translate(0, 0) scale(0.75)',
    `translate(0, ${calcEm(28, 18)}) scale(1)`
  )};
  transition: transform 200ms ease-out;
  z-index: 1;
  pointer-events: none;

  & + ${SelectWrapper} {
    margin-top: 1em;
  }
`

export default SelectLabel
